// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"57527c2a","455":"26bba858","977":"681662ed"}[chunkId] + ".chunk.js";
};